export default function filterTime(val) {
  const date = new Date(val)
  const minute = date.getMinutes()
  const hours = date.getHours()
  const result = `${hours < 10 ? '0' + hours : hours}:${
    minute < 10 ? '0' + minute : minute
  }`
  return result
}